import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';

export default function YourPrivacyPage() {
  return (
    <div className="landing">
      <PublicHeader />

      <main className="your-privacy-page">
        <div className="your-privacy-content">
          <h1>Your privacy, simply explained</h1>
          <p className="your-privacy-intro">
            Handing over access to your inbox is a big deal. Here's exactly what
            The Email Helper can see, what we store, and what we will never do — no
            legal jargon.
          </p>

          <div className="privacy-commitment">
            <div className="privacy-commitment-icon" aria-hidden="true">🔒</div>
            <div>
              <strong>We never train AI models on your emails.</strong>
              <p>Your inbox data is never used to train, fine-tune, or improve any AI model — ours or anyone else's. Full stop.</p>
            </div>
          </div>

          <section className="your-privacy-section">
            <h2>What does The Email Helper actually see?</h2>
            <p>
              We scan your email metadata — sender address, subject line, and date received — to detect subscriptions, invoices, and other categories. That's it for the routine background work.
            </p>
            <p>
              For smart reply drafting (coming soon), we may read the body of emails you <em>specifically ask us to respond to</em>, and nothing else. We process what's needed in the moment and don't retain the content.
            </p>
            <p>
              We never read or store your entire email history in full. We take what we need to do the job and discard the rest.
            </p>
          </section>

          <section className="your-privacy-section">
            <h2>Do you train AI models on my emails?</h2>
            <p>
              No. Your emails are <strong>never</strong> used to train, fine-tune, or improve any AI model — ours or anyone else's.
            </p>
            <p>
              When AI is used to categorise emails or draft a response, your data is processed in the moment for that specific task. It is not retained by the model, added to any training dataset, or shared with a model provider for improvement purposes.
            </p>
          </section>

          <section className="your-privacy-section">
            <h2>What do you actually store?</h2>
            <p>We store the minimum needed to run the service:</p>
            <ul className="your-privacy-list">
              <li>Sender address, subject line, and date — so we can show you your subscription list</li>
              <li>A category label (e.g. "subscription") — so we know how to handle each sender</li>
              <li>Your Gmail OAuth token — stored securely so we can act on your behalf (e.g. archive emails)</li>
            </ul>
            <p>
              We do <strong>not</strong> store full email bodies. We do not store attachments. We do not build a profile of your behaviour to sell or share.
            </p>
          </section>

          <section className="your-privacy-section">
            <h2>Who can see my data?</h2>
            <p>
              Only you. Our engineering team has no routine access to your email data — access controls are enforced at the database level.
            </p>
            <p>
              We do not sell data. We do not share data with advertisers or analytics platforms. We do not use your emails to serve you ads anywhere.
            </p>
          </section>

          <section className="your-privacy-section">
            <h2>What if I want to delete everything?</h2>
            <p>
              You can disconnect Gmail from <strong>Settings → Connected accounts</strong> at any time. This immediately revokes our access token — we can no longer read or act on your inbox.
            </p>
            <p>
              To delete all stored data, email{' '}
              <a href="mailto:privacy@theemailhelper.com">privacy@theemailhelper.com</a>{' '}
              and we'll process your request within 30 days. Full self-serve data deletion is on our roadmap.
            </p>
          </section>

          <div className="your-privacy-policy-link">
            <Link to="/privacy">Read our full Privacy Policy →</Link>
          </div>
        </div>
      </main>

      <footer className="landing-footer">
        © {new Date().getFullYear()} Oblivion Solutions Limited ·{' '}
        <Link to="/privacy">Privacy</Link>
      </footer>
    </div>
  );
}
